import $foreign from "./foreign.cjs";
var defer = $foreign.defer;
var force = $foreign.force;
export { defer, force };
